import { get, post } from '../utils/axios'

export const getContractSettingAPI = async (body) => {
  return await get('contract/setting', body)
}

export const getContractSettingAPI2 = async (body) => {
  return await get('contract/setting/get')
}

export const postContractSettingAPI = async (param) => {
  return await post('contract/setting/post', param)
}

// at the same
export const putContractSettingAPI = async (param) => {
  return await post('contract/setting/put', param)
}

export const deleteContractSettingAPI = async (param) => {
    return await post('contract/setting/delete', param)
  }
  